/* eslint-disable */
// @ts-nocheck

import { ChevronDown } from 'lucide-react'
import { MouseEventHandler } from 'react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export interface IDropdownOption {
  label: string
  icon?: React.ReactNode
  onClick: MouseEventHandler<HTMLDivElement>
}

export interface IDropdownTableHeader {
  type: 'dropdown'
  label: string
  options: IDropdownOption[]
}
type Props = Omit<IDropdownTableHeader, 'type'>
export const DropdownTableHeader: React.FC<Props> = ({ label, options }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          aria-label={label}
          className="h-8 gap-1"
          size="sm"
          variant="outline"
        >
          <span>{label}</span>
          <ChevronDown className="h-3.5 w-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>{label}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {options.map((option, index) => (
          <DropdownMenuItem
            className="cursor-pointer"
            key={index}
            onClick={option.onClick}
          >
            {option.icon}
            <span className="ml-2">{option.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
